import { render, staticRenderFns } from "./HabitsTable.vue?vue&type=template&id=f2c28650&scoped=true&"
import script from "./HabitsTable.vue?vue&type=script&lang=js&"
export * from "./HabitsTable.vue?vue&type=script&lang=js&"
import style0 from "./HabitsTable.vue?vue&type=style&index=0&id=f2c28650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c28650",
  null
  
)

export default component.exports